import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import MuiIconButton from '@mui/material/IconButton';

import { pinkishOrange } from '~/styles';

import { MenuItemStyles } from './elements';

interface MenuListButtonProps {
  onClick?(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void;
  Icon: React.ReactNode;
  loading: boolean;
  buttonText: string;
  displayIcon?: boolean;
}

const Button = styled(MuiIconButton)`
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
  line-height: 0;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: black;
  &:hover {
    background: none;
  }
  ${MenuItemStyles}
  gap: 2px;
`;

export const MenuListButton: React.FC<PropsWithChildren<MenuListButtonProps>> = ({
  onClick,
  Icon,
  loading,
  buttonText,
  displayIcon = false,
  ...props
}) => {
  return (
    <Box position="relative" width="100%">
      <Button onClick={onClick} style={{ height: '33px' }} {...props}>
        {displayIcon && (
          <Box position="relative" marginRight="4px">
            {loading && (
              <CircularProgress
                size={28}
                style={{
                  position: 'absolute',
                  top: -2,
                  left: -2,
                  color: pinkishOrange,
                }}
              />
            )}
            {Icon}
          </Box>
        )}
        {buttonText}
      </Button>
    </Box>
  );
};
